import React from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import BrandLogo from "@/components/marketing/BrandLogo";
import { LayoutGrid, Building2, Users, Package, Activity, LogOut, ArrowLeft, CreditCard, Settings, BookOpen, Mail } from "lucide-react";

const NAV = [
  { to: "", end: true, label: "Overview", Icon: LayoutGrid, testid: "admin-nav-overview" },
  { to: "tenants", label: "Tenants", Icon: Building2, testid: "admin-nav-tenants" },
  { to: "users", label: "Users", Icon: Users, testid: "admin-nav-users" },
  { to: "packages", label: "Packages", Icon: Package, testid: "admin-nav-packages" },
  { to: "payments", label: "Payments", Icon: CreditCard, testid: "admin-nav-payments" },
  { to: "usage", label: "Platform Usage", Icon: Activity, testid: "admin-nav-usage" },
  { to: "knowledge-base", label: "Knowledge Base", Icon: BookOpen, testid: "admin-nav-knowledge" },
  { to: "emails", label: "Email Log", Icon: Mail, testid: "admin-nav-emails" },
  { to: "settings", label: "Settings", Icon: Settings, testid: "admin-nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex bg-[#F9FAFB]">
      <aside className="w-64 bg-[#0F1115] text-white p-4 flex flex-col">
        <Link to="/admin" className="flex items-center gap-2 px-2 py-3 mb-4 text-white">
          <BrandLogo size="md" />
        </Link>
        <div className="px-2 -mt-3 mb-4">
          <div className="font-display font-extrabold leading-tight text-white text-sm">Super Admin</div>
          <div className="font-mono text-[10px] text-white/40">platform control</div>
        </div>
        <nav className="flex-1 space-y-1">
          {NAV.map(({ to, end, label, Icon, testid }) => (
            <NavLink key={label} to={to} end={end} data-testid={testid} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => { logout(); nav("/login"); }} data-testid="admin-logout-button" className="sidebar-link text-red-300 hover:!bg-red-500/10">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </aside>
      <div className="flex-1 flex flex-col min-w-0">
        <header className="border-b border-[#E2E8F0] bg-white px-8 py-4 flex items-center justify-between">
          <div>
            <div className="font-mono text-[11px] text-[#4B5563] uppercase tracking-wide">super admin</div>
            <div className="font-display font-bold text-lg">{user?.name}</div>
          </div>
        </header>
        <main className="flex-1 p-8 overflow-auto"><Outlet /></main>
      </div>
    </div>
  );
}
